/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      name
      athleteName
      registrationOpen
      registrationClose
      startDate
      endDate
      addressOne
      addressTwo
      city
      zip
      state
      cost
      refundPolicy
      contact
      description
      bannerImage
      athleteImage
      sport
      slug
      registrationURL
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      name
      athleteName
      registrationOpen
      registrationClose
      startDate
      endDate
      addressOne
      addressTwo
      city
      zip
      state
      cost
      refundPolicy
      contact
      description
      bannerImage
      athleteImage
      sport
      slug
      registrationURL
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      name
      athleteName
      registrationOpen
      registrationClose
      startDate
      endDate
      addressOne
      addressTwo
      city
      zip
      state
      cost
      refundPolicy
      contact
      description
      bannerImage
      athleteImage
      sport
      slug
      registrationURL
      startTime
      endTime
      createdAt
      updatedAt
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      school
      sport
      phone
      referral
      message
      email
      createdAt
      updatedAt
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      school
      sport
      phone
      referral
      message
      email
      createdAt
      updatedAt
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      school
      sport
      phone
      referral
      message
      email
      createdAt
      updatedAt
    }
  }
`;
